exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard .scroll-div .grid-body {\n  height: 400px;\n  width: 100%;\n  overflow: scroll;\n}\n.dashboard .scroll-div .table th {\n  position: sticky;\n  top: -1px;\n}\n.dashboard .flex {\n  display: flex;\n  width: 100%;\n}\n.dashboard .flex .grid {\n  width: 100%;\n  height: 100%;\n}\n.dashboard .loading {\n  bottom: 0px;\n  font-size: 150px;\n  position: fixed;\n  padding-top: 20%;\n  top: 0px;\n  text-align: center;\n  width: 100%;\n  left: 0px;\n  right: 0px;\n  background: rgba(255, 255, 255, 0.6588235294);\n  color: rgba(32, 37, 41, 0.6392156863);\n  z-index: 2;\n}", ""]);

// exports
